import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './redux';
import { PersistGate } from 'redux-persist/integration/react';  // Import PersistGate
import { persistor } from './redux';  // Import persistor


// const App = () => <div>Hello</div>;

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
    {/* <BrowserRouter> */}
      <App />

    {/* </BrowserRouter> */}
    </PersistGate>
    </Provider>
  </React.StrictMode>
);